import { memo } from "react";
import stylesCss from './dropdown.module.css'

export default memo(function Dropdown({ options, onChange, style, id, label }) {
    return (
        <>
            {label && <label htmlFor={id}>{label}</label>}
            <select id={id} onChange={onChange} style={style} className={stylesCss.globalDropdown}>
                <option value=''> -- Select -- </option>
                {options.map((e) => <option value={e.value} key={e.value}>{e.label}</option>)}
            </select>
        </>
    )
})